/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import { Tree, message } from 'antd'
import classNames from 'classnames'
import Icon from 'meinian-package/src/component/icon'
import Input from 'meinian-package/src/baseComponent/input'
import Modal from 'meinian-package/src/component/modal'
import { convert } from './userDefinedProps'
import './treeList.less'

let dragObj = {}
let ar
let i
let iTreeKeyItem = 0

export default (props) => {
  const { data = [], setData } = props
  const [treeData, setTreeData] = useState([])
  const [expandedKeys, setExpandedKeys] = useState([])
  const [autoExpandParent, setAutoExpandParent] = useState(true)

  useEffect(() => {
    if (data.length > 0) {
      setTreeData(generateData(data))
    } else {
      setTreeData([])
    }
  }, [data])
  const loopList = (data, key, callback) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].key == key) {
        return callback(data[i], i, data)
      }
      if (data[i].children.length > 0) {
        loopList(data[i].children, key, callback)
      }
    }
  }
  const onDrop = (info) => {
    const dropKey = info.node.props.eventKey // 拖拽父级的key
    const dragKey = info.dragNode.props.eventKey
    const dropPos = info.node.props.pos.split('-')
    const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
    // const dragNode = info.node.props.node
    const dropNode = info.node.props.node
    if (dropNode === 3) {
      if (info.dragNode.props.childItems.length > 0) {
        return message.warning('最多只支持三级')
      }
    }
    if (dropNode === 2) { // 放到里面只能有1层
      const list = info.dragNode.props.childItems
      const item = list.find(m => m.childItems.length > 0)
      if (dropPosition === 1 || (!info.dropToGap && dropPosition === 0)) {
        if (list.length > 0) {
          return message.warning('最多只支持三级')
        }
      } else if (list.length > 0 && item) {
        return message.warning('最多只支持三级')
      }
    }
    if (dropNode === 1 && (dropPosition === 1 || (!info.dropToGap && dropPosition === 0))) { // 放到里面最多两层
      const list = info.dragNode.props.childItems
      const item = list.find(m => m.childItems.length > 0)
      if (list.length > 0 && item) {
        return message.warning('最多只支持三级')
      }
    }
    const data = treeData
    loopList(data, dragKey, (item, index, arr) => {
      arr.splice(index, 1)
      dragObj = item
    })
    if (!info.dropToGap) {
      loopList(data, dropKey, (item) => {
        item.children = item.children || []
        item.children.unshift(dragObj)
      })
    } else if (
      (info.node.props.children || []).length > 0
      && info.node.props.expanded
      && dropPosition === 1
    ) {
      loopList(data, dropKey, (item) => {
        item.children = item.children || []
        item.children.unshift(dragObj)
      })
    } else {
      // let ar
      // let i
      loopList(data, dropKey, (item, index, arr) => {
        ar = arr
        i = index
      })
      if (dropPosition === -1) {
        ar.splice(i, 0, dragObj)
      } else {
        ar.splice(i + 1, 0, dragObj)
      }
    }
    setData(pre => [...pre])
    setTreeData(pre => [...convert(pre)])
  }
  const generateData = (data) => {
    data?.map((item) => {
      item.title = (<Item
        item={item}
        {...props}
        data={data}
        onAddSubItem={onAddSubItem}
        onRemoveItem={onRemoveItem}
        setData={setData}
        loopList={loopList}
      />)
      item.children = item.childItems
      let children = item.childItems
      if (children.length > 0) {
        children = generateData(children)
      }
    })
    return data
  }

  const covertPush = (data, key, v) => {
    data.forEach((item) => {
      if (item.key === key) {
        item.childItems.push(v)
      } else {
        covertPush(item.childItems, key, v)
      }
    })
    return data
  }
  const onAddSubItem = (item) => {
    const { node, key } = item
    if (node > 2) {
      return
    }
    // 根据父元素的id来判断
    if (item.childItems.length >= 99) return message.warning('最多添加99条子选项')
    const newData = covertPush(data, key, { node: node + 1, childItems: [], value: '', key: `${item.key}-${iTreeKeyItem++}` })
    convert(newData)
    setData([...newData])
    setExpandedKeys([item.key])
    setAutoExpandParent(true)
  }

  const covertFind = (data, key) => {
    data.forEach((item, index) => {
      if (item.key === key) {
        data.splice(index, 1)
      } else {
        covertFind(item.children, key)
      }
    })
    return data
  }

  const onRemoveItem = (item) => {
    const { key } = item

    // 找到当前元素的父元素
    // let parentList
    // loopList(data, key, (_, index, arr) => {
    //   parentList = arr
    // })

    if (item.childItems.length > 0) {
      Modal.show({
        hiddenCloseIcon: true,
        style: { width: 416, minHeight: 152 },
        className: 'mn-update-property-attention-modal',
        children: <div className="property-desc-wrap">
          <Icon type="m-zhuyi_tianchong" style={{ fontSize: 24, color: '#ED7E28' }} />
          <span className="description">确认删除该选择项及其所有子选择项？</span>
        </div>,
        onOk: () => {
          const _newData = covertFind(data, key)
          setData([..._newData])
        }
      })
    } else {
      const _newData = covertFind(data, key)
      setData([..._newData])
    }
  }

  const onExpand = (_expandedKeys) => {
    setExpandedKeys(_expandedKeys)
    setAutoExpandParent(false)
  }
  return <div>
    {treeData.length > 0 ? <Tree
      className="mn-draggable-tree"
      draggable
      blockNode
      onExpand={(key, obj) => onExpand(key, obj)}
      autoExpandParent={autoExpandParent}
      expandedKeys={expandedKeys}
      onDrop={onDrop}
      treeData={treeData}
    /> : null}
  </div>
}

const Item = (props) => {
  const { item = {}, onAddSubItem, onRemoveItem, setData, loopList, data } = props
  const { node, key } = item
  const [isEmpty, setIsEmpty] = useState(false)

  useEffect(() => {
    if (!item.value) {
      setIsEmpty(true)
      return
    }
    setIsEmpty(false)
  }, [item])

  const onChangeValue = (value, item) => {
    if (!value || /[\^|=]/.test(value)) {
      setIsEmpty(true)
      message.warning('值不能为空，且不能包含字符「^」和「=」')
    } else {
      setIsEmpty(false)
    }
    item.value = value
    setData(pre => [...pre])
  }
  const onBlur = (value, item) => {
    if (!value) {
      setIsEmpty(true)
    } else {
      setIsEmpty(false)
    }
    let parentList
    loopList(data, item.key, (_, index, arr) => {
      parentList = arr
    })
    const sameList = parentList?.filter(m => (m.value && m.value == value))
    props.onChange(sameList.length > 1 ? 'true' : false)
    if (sameList.length > 1) {
      message.warning('同一级选项的名称不能相同')
    }
  }
  const onFocus = (value) => {
    if (!value) {
      setIsEmpty(true)
    } else {
      setIsEmpty(false)
    }
  }
  return <div className="list-item-wrap">
    <div className="list-item">
      <Icon type="m-tuodong" style={{ fontSize: 24, color: '#666' }} />
      <Input
        wrapClassName={classNames('property-name-input', { empty: isEmpty })}
        wrapStyle={{ width: 'calc(100% - 44px)' }}
        id={key}
        maxLength={20}
        value={item?.value}
        onBlur={e => onBlur(e.target.value, item)}
        onFocus={e => onFocus(e.target.value)}
        onChange={e => onChangeValue(e.target.value, item)}
      />
      <Icon type="m-jianshao_miaobian" style={{ marginLeft: 4 }} onClick={() => { onRemoveItem(item) }} />
    </div>
    { node > 2 ? null : <a
      className="add-sub-item"
      onClick={() => { onAddSubItem(item) }}
    >
      <Icon type="m-tianjia" style={{ color: 'var(--m-success-normal)' }} />添加子选项
    </a>}
  </div>
}
